import React, { useRef, useEffect, useState } from 'react';
import { Container, Row, Col, Modal } from 'react-bootstrap';
import '../../custom.css';
import Footer from './Footer';
import ContactUsForm from './ContactUsForm';
import { motion } from 'framer-motion';
import AOS from 'aos';
import 'aos/dist/aos.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import ThreeCApproach from './ThreeCApproach';
import AiVisualization from './AiVisualization';

function About() {
    // State for handling modal visibility
    const [showModal, setShowModal] = useState(false);
    
    /*
    const testimonials = [
        {
            quote: "We used to run promos based on gut feeling or based on whatever our competitors were doing. Sometimes it worked, sometimes we just ate margin. With ARAMA, I finally feel confident we're making the right call. And even when we miss, I know it's learning and the next rec will be better.",
            name: "Gudrun K.",
            role: "Founder",
            company: "Boutique Home Goods Store"
        },
        {
            quote: "Other tools gave us dashboards and said 'good luck'. With ARAMA, we get clear guidance like 'Drop this SKU by 17%. Here's why.' It's freakishly smart, like having a pricing nerd on payroll.",
            name: "Michael T.",
            role: "Head of Merchandising",
            company: "Men's Streetwear Brand (Shopify, 300+ SKUs)"
        },
        {
            quote: "In just three months, our margins are up 4% and we haven't even rolled it out to all products. I didn't expect results this fast.",
            name: "Sania R.",
            role: "eStore Manager",
            company: "Wellness DTC Brand (~120 SKUs, Shopify)"
        },
        {
            quote: "Honestly, I didn't think pricing automation would work for a small store like ours. But ARAMA nailed it. We saw better sell-through in the first week. Now I just wait for the next pricing card.",
            name: "Tobias E.",
            role: "Co-owner",
            company: "Handmade Accessories Shop"
        },
        {
            quote: "I used to spend hours tweaking prices and second-guessing everything. ARAMA cut that to 10 minutes a week and somehow, our margins are up too.",
            name: "Laura M.",
            role: "Owner",
            company: "Eco Apparel Brand"
        }   
    ];
    */
    const heroRef = useRef(null);

    // Functions to open and close the modal
    const handleCloseModal = () => setShowModal(false);

    // Initialize AOS animation library
    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: false,
            mirror: true,
        });
    }, []);


    return (
        <div className='modern-ai-theme about-us-page'>
            {/* Modern grid background with lines */}
            <div className="grid-lines"></div>
            
            {/* Hero section */}
            <section className="modern-hero" ref={heroRef}>
                <div className="hero-blob"></div>
                <Container>
                    <Row className="align-items-center justify-content-center">
                        <Col lg={6} md={12} className="hero-content order-lg-1 mb-4 mb-lg-0">
                            <motion.div
                                initial={{ opacity: 0, y: 30 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.8 }}
                            >
                                <h2 className="mb-4">Who Are <span style={{ color: 'var(--ai-teal)' }}>We?</span></h2>
                                <h3 className="mb-4">We're on a mission to put pricing power back in the hands of small brands.</h3>
                                <p className="mb-4">
                                    Big brands have pricing teams and millions in margin software. Indie stores have spreadsheets. That's not fair — and we're here to fix it.
                                </p>
                            </motion.div>
                        </Col>
                        <Col lg={6} md={12} className="order-lg-2">
                            <AiVisualization />
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Mission Section */}
            <section className="py-5 my-5">
                <Container>
                    <Row className="align-items-center justify-content-center text-center">
                        <Col xs={12} md={10} lg={8} className="glass-card" data-aos="fade-up">
                            <div className="section-title-container">
                                <h2>Our <span style={{ color: 'var(--ai-teal)' }}>Mission</span></h2>
                                <div className="title-underline"></div>
                            </div>
                            <h4>We believe that small businesses deserve the same pricing clarity as the giants.</h4>
                            <p>
                                ARAMA turns pricing into a strategic advantage, not a spreadsheet chore. It watches what works, learns what doesn't, and delivers your next move...clearly and confidently.
                            </p>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Values Section - Enhanced 3C Approach */}
            <ThreeCApproach />

            {/* Why Choose Us Section */}
            <section className="py-5 my-5">
                <Container>
                    <motion.div
                        className="text-center mb-5"
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5 }}
                    >
                        <h2 className="mb-3 position-relative d-inline-block">
                            Why Choose <span style={{ color: 'var(--ai-teal)' }}>ARAMA?</span>
                            <motion.div 
                                className="title-underline-animated"
                                initial={{ width: 0 }}
                                whileInView={{ width: '100%' }}
                                viewport={{ once: true }}
                                transition={{ duration: 1, delay: 0.5 }}
                                style={{
                                    position: 'absolute',
                                    bottom: '-10px',
                                    left: 0,
                                    height: '3px',
                                    background: 'var(--ai-gradient-1)',
                                    borderRadius: '2px'
                                }}
                            />
                        </h2>
                        {/*
                        <p className="mb-4 mx-auto" style={{ maxWidth: '700px' }}>
                            Don't take our word for it. Here's what our customers are saying about ARAMA.
                        </p>
                        */}
                    </motion.div>
                    
                    <Row className="align-items-stretch">
                        {/* Testimonials section - temporarily hidden */}
                        {/* 
                        <Col lg={6} md={12} className="mb-4 mb-lg-0" data-aos="fade-right">
                            <div className="glass-card h-100">
                                <h3 className="mb-4 position-relative">
                                    What Our Customers <span style={{ color: 'var(--ai-teal)' }}>Say</span>
                                    <div className="title-underline" style={{ width: '60px', margin: '10px 0 0 0' }}></div>
                                </h3>
                                <div className="pricing-manifesto">
                                    <div className="vertical-progress-container">
                                        {testimonials.map((_, index) => (
                                            <div 
                                                key={`progress-${index}`}
                                                className={`progress-indicator ${index === activeSlide ? 'active' : ''}`}
                                                onClick={() => handleTestimonialSelect(index)}
                                            />
                                        ))}
                                    </div>
                                    <div className="manifesto-statement">
                                        {testimonials.map((testimonial, index) => (
                                            <motion.div
                                                key={`testimonial-${index}`}
                                                className={`carousel-slide ${
                                                    index === activeSlide 
                                                        ? 'active' 
                                                        : index === (activeSlide - 1 + testimonials.length) % testimonials.length 
                                                            ? 'prev' 
                                                            : index === (activeSlide + 1) % testimonials.length 
                                                                ? 'next' 
                                                                : ''
                                                }`}
                                                initial={false}
                                                animate={{ 
                                                    opacity: index === activeSlide ? 1 : 0,
                                                    y: index === activeSlide 
                                                        ? '-50%' 
                                                        : index === (activeSlide - 1 + testimonials.length) % testimonials.length 
                                                            ? '-200%' 
                                                            : '200%',
                                                    scale: index === activeSlide ? 1 : 0.8,
                                                    zIndex: index === activeSlide ? 2 : 1
                                                }}
                                                transition={{ 
                                                    duration: 0.8, 
                                                    ease: [0.645, 0.045, 0.355, 1.000]
                                                }}
                                            >
                                                <div className="customer-quote">
                                                    {testimonial.quote}
                                                </div>
                                                <div className="customer-info">
                                                    <span className="customer-name">{testimonial.name}</span>
                                                    <span className="customer-role">{testimonial.role}</span>
                                                    <span className="customer-company">{testimonial.company}</span>
                                                </div>
                                            </motion.div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </Col>
                        */}
                        <Col lg={12} md={12} data-aos="fade-up">
                            <div className="glass-card">
                                <Row className="g-4">
                                    {[
                                        {
                                            icon: "bi-stopwatch",
                                            title: "5-minute setup",
                                            description: "Connect once and start optimizing prices immediately, no technical skills required."
                                        },
                                        {
                                            icon: "bi-bar-chart",
                                            title: "Built-in A/B testing",
                                            description: "Every price change is proven with real sales data, not theory or guesswork."
                                        },
                                        {
                                            icon: "bi-graph-up-arrow",
                                            title: "Proven margin lift",
                                            description: "Average 3.2 percentage point increase in gross margin."
                                        },
                                        {
                                            icon: "bi-people",
                                            title: "No data team needed",
                                            description: "ARAMA is your pricing expert, data scientist, and automation engine all in one."
                                        }
                                    ].map((benefit, index) => (
                                        <Col md={6} key={`benefit-${index}`}>
                                            <motion.div 
                                                className="benefit-item h-100"
                                                initial={{ opacity: 0, y: 20 }}
                                                whileInView={{ opacity: 1, y: 0 }}
                                                viewport={{ once: true }}
                                                transition={{ duration: 0.5, delay: 0.3 + (index * 0.15) }}
                                            >
                                                <i className={`bi ${benefit.icon} me-2 mb-2`} style={{ color: 'var(--ai-teal)', fontSize: '1.5rem' }}></i>
                                                <div>
                                                    <h5 className="mb-2">{benefit.title}</h5>
                                                    <p className="mb-0">{benefit.description}</p>
                                                </div>
                                            </motion.div>
                                        </Col>
                                    ))}
                                </Row>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Founder Section */}
            {/*
            <section className="py-5 my-5 founder-section">
                <Container>
                    <Row className="justify-content-center text-center mb-4">
                        <Col lg={8}>
                            <h2 className="mb-3">Meet The <span style={{ color: 'var(--ai-teal)' }}>Founder</span></h2>
                        </Col>
                    </Row>
                    <Row className="align-items-center mb-5">
                        <Col lg={4} md={6} className="mb-4 mb-lg-0 mx-auto" data-aos="fade-right">
                            <div className="founder-image-container text-center">
                                <div className="avatar-circle">
                                    <img 
                                        src="/founder.jpg" 
                                        alt="Nikhil - Founder & CEO" 
                                        style={{ 
                                            width: '10rem', 
                                            height: '10rem', 
                                            objectFit: 'cover',
                                            objectPosition: 'center',
                                            borderRadius: '50%'
                                        }}
                                    />
                                    <div className="founder-glow"></div>
                                </div>
                                <h3 className="mt-3" style={{ color: 'var(--ai-teal)' }}>Nikhil</h3>
                                <p className="founder-title">Founder & CEO</p>
                            </div>
                        </Col>
                        <Col lg={8} md={12} data-aos="fade-left">
                            <div className="glass-card founder-bio">
                                <p>
                                    Nikhil has built AI products at scale, driven 7-figure impact, and led data teams across Europe. He started ARAMA to level the playing field — so that small businesses don't need to guess their way through pricing ever again.
                                </p>
                                <div className="founder-signature">
                                    <motion.div 
                                        className="signature-element"
                                        initial={{ width: 0 }}
                                        whileInView={{ width: '120px' }}
                                        transition={{ duration: 1 }}
                                        viewport={{ once: true }}
                                    ></motion.div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
            */}
            <Footer />

            {/* Contact Us Modal */}
            <Modal show={showModal} onHide={handleCloseModal} centered size="lg">
                <Modal.Header closeButton className="border-0">
                    <Modal.Title className="w-100 text-center">Get Your AI Business Advisor</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ContactUsForm closeModal={handleCloseModal} />
                </Modal.Body>
            </Modal>
        </div>
    );
}

export default About;
